module.exports = __webpack_public_path__ + "img/dr.hoangtuan(cam-trang).e8cec6e7.png";